import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChild
} from "@angular/core";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
@Component({
  selector: 'upsc-custom-paginator',
  templateUrl: './custom-paginator.component.html',
  styleUrls: ['./custom-paginator.component.scss']
})
export class CustomPaginatorComponent implements OnInit {
  length: number;
 
  public formGroup: UntypedFormGroup;
  public pageSize: number = 10;
  @Output() data = new EventEmitter();
  public totalNumPages : number;
  @Input() pageIndex: number =1;
  public finalIndex : boolean;
  @Input() pageSizeLabel: string = 'Results per page';
    
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @Input() pageSizeOptions: number[];
  @Output() page = new EventEmitter<PageEvent>();

  @Input("length") set lengthChanged(length: number) {
    this.length = length;
    this.totalNumPages = Math.ceil(this.length / this.pageSize);
    this.pageIndex = 1;
    this.finalIndex = this.pageIndex >= this.totalNumPages ? true : false;
  }

  @Input() customDDLPageSize: number = 10;

  constructor(
    private formBuilder: UntypedFormBuilder,
  ) {}

  ngOnInit() {
   
    this.formGroup = this.formBuilder.group({
      txtPageNumber: 1 ,
      ddlPageSize: this.customDDLPageSize,
    });
    this.pageSize = this.customDDLPageSize;

    this.formGroup.controls.txtPageNumber.valueChanges
      .subscribe(
        (value) => {
          if(value.length > 0){
            this.pageIndex = value;
            this.finalIndex = this.pageIndex >= this.totalNumPages ? true : false;

            const event: PageEvent = {
              length: this.length,
              pageIndex: value,
              pageSize: this.pageSize
            };
            if(this.totalNumPages >= +value){
              this.emitPageEvent(event);
            }
        }
      }
      );
    this.totalNumPages = Math.ceil(this.length / this.pageSize);
  }

  emitPageEvent(pageEvent: PageEvent) {
    this.finalIndex = this.pageIndex >= this.totalNumPages ? true : false;
    this.data.emit(pageEvent);
  }

  onKeypressEvent(event: any, form){
      var key=event.which || event.KeyCode;

      if ((key === 46 || key === 48) && event.target.selectionStart === 0) {
        return false;
      }

      if( key >= 48 && key <= 57){
        if(this.totalNumPages < +(form.txtPageNumber + '' + event.key)){
          return false;
        }
        return true; 
      }
      else return false;
    }

  setResultPerPage(form) {
    this.totalNumPages = (Math.ceil(this.length / this.pageSize));
    this.pageIndex = 1;
    const event: PageEvent = {
      length: this.length,
      pageIndex: this.pageIndex,
      pageSize: this.pageSize
    };
    // this.formGroup.patchValue({
    //   txtPageNumber :this.pageIndex
    // });
    this.emitPageEvent(event);
  }

  previous(){
    if(+this.pageIndex > 1){
      this.pageIndex = +this.pageIndex - 1;
    const event: PageEvent = {
      length: this.length,
      pageIndex: this.pageIndex,
      pageSize: this.pageSize
    };
    // this.formGroup.patchValue({
    //   txtPageNumber :this.pageIndex
    // });
    this.emitPageEvent(event);
  }
}
  next(){
    if(+this.pageIndex < this.totalNumPages){
    this.pageIndex = +this.pageIndex + 1;
    const event: PageEvent = {
      length: this.length,
      pageIndex: this.pageIndex,
      pageSize: this.pageSize
    };
    // this.formGroup.patchValue({
    //   txtPageNumber :this.pageIndex
    // });
    this.emitPageEvent(event);
  }}
}
